// * Base
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { Injectable, Inject } from '@angular/core';

import { SERVER_ERRORS_CONFIG_TOKEN, SntServerErrorsModuleConfig } from './config';
import {
  excludeKeys,
  SntServerError,
  mapNestedErrors,
  retrieveFormErrors,
  SntServerErrorFilterFn,
  SntServerErrorOptions,
  scrollToInvalidControl,
} from './server-errors.helpers';

@Injectable()
export class SntServerErrorsService {
  constructor(@Inject(SERVER_ERRORS_CONFIG_TOKEN) private config: SntServerErrorsModuleConfig) {}

  mapErrors(form: FormGroup | FormArray, errors: SntServerError, options?: SntServerErrorOptions) {
    this.mapErrorsToForm(form as FormGroup, errors, options ? { ...options, enableScrollToError: false } : options);
    this.mapErrorsToFormControls(form, errors, options ? { ...options, enableScrollToError: false } : options);

    if (options?.enableScrollToError) {
      scrollToInvalidControl({ target: options.scrollTarget, selector: options.scrollSelector });
    }
  }

  mapErrorsToFormControls(form: FormGroup | FormArray, errors: SntServerError, options?: SntServerErrorOptions) {
    errors = this._preprocessErrors(errors, options?.filterFn);

    const fields = Object.keys(errors);

    for (const field of fields) {
      mapNestedErrors(form, field, [field], errors);
    }
  }

  mapErrorsToForm(form: FormGroup, errors: SntServerError, options?: SntServerErrorOptions) {
    errors = this._preprocessErrors(errors, options?.filterFn);
    const formErrors = retrieveFormErrors(form, errors);

    if (formErrors.length) {
      form.setErrors({ server: formErrors });
    }
  }

  mapErrorsToControl(control: AbstractControl, errors: string | string[], options?: SntServerErrorOptions) {
    if (errors?.length) {
      control.setErrors({ server: Array.isArray(errors) ? errors[0] : errors });

      if (options?.enableScrollToError) {
        scrollToInvalidControl({ target: options.scrollTarget, selector: options.scrollSelector });
      }
    }
  }

  private _preprocessErrors(errors: SntServerError, filterFn?: SntServerErrorFilterFn) {
    let preprocessed = errors;

    if (typeof (errors as unknown) === 'string' && errors) {
      preprocessed = JSON.parse(errors as unknown as string);
    }

    if (Array.isArray(this.config.excludeKeys)) {
      preprocessed = excludeKeys(this.config.excludeKeys)(preprocessed);
    }

    if (filterFn) {
      preprocessed = filterFn(preprocessed);
    }

    return preprocessed;
  }
}
